import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Members from '../../pages/Members';
import SearchGen from './SearchGen';

export default function DialogueAllmenbers() {

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };






  return (
    <React.Fragment>
      <Button sx={{background:"red",color:"white", marginLeft:"3px"}} variant="contained" onClick={handleClickOpen}>
         General Search
      </Button>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth=""
        fullWidth
      >
        <DialogTitle id="alert-dialog-title">
          {"General Member Search"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
           
           

          <SearchGen />

          </DialogContentText>
        </DialogContent>
        <DialogActions>


           

          <Button onClick={handleClose}>Cancel</Button>
        

        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}